import { MedicationRequestStatus } from "@shared/enums/medicationRequest"
import { PageRequest } from "@shared/zod/schemas/requests/page"
import {
  MedicationRequestDetailResponse,
  MedicationRequestPageResponse,
} from "@shared/zod/schemas/responses/medicationRequest"

import { axiosAuth } from "./generic/AxiosInterceptor/AxiosInterceptor"

export const findAll = (query?: PageRequest): Promise<MedicationRequestPageResponse> => {
  return axiosAuth({
    url: "/medicationrequests",
    method: "get",
    params: query,
  }).then((resp) => resp.data)
}

export const get = (id: string): Promise<MedicationRequestDetailResponse> => {
  return axiosAuth({
    url: `/medicationrequests/${id}`,
    method: "get",
  }).then((resp) => resp.data)
}

export const status = (id: string, status: MedicationRequestStatus): Promise<void> => {
  return axiosAuth({
    url: `/medicationrequests/${id}`,
    method: "patch",
    data: { status },
  }).then(() => undefined)
}
